module.exports = __webpack_public_path__ + "static/media/aceton_1.46e21fbb.png";